// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export interface XCustomPageLinksState {
    areCustomPageLinksLoading: boolean;
}

const initialState: XCustomPageLinksState = {
    areCustomPageLinksLoading: false,
};

const reducer = {
    "CustomPageLinks/BeginLoadCustomPageLinks": (draft: Draft<XCustomPageLinksState>) => {
        draft.areCustomPageLinksLoading = true;
    },
    "CustomPageLinks/CompleteLoadCustomPageLinks": (draft: Draft<XCustomPageLinksState>) => {
        draft.areCustomPageLinksLoading = false;
    },
};

const xCustomPageLinks = createTypedReducerWithImmer(initialState, reducer);

(reducers as any).xCustomPageLinks = xCustomPageLinks;

export interface xCustomPageLinksState {
    xCustomPageLinks: XCustomPageLinksState;
}

export type xCustomPageLinksActions = Parameters<typeof xCustomPageLinks>[1] | AnyAction;